if (typeof customElements.get('social-proof-bar') === 'undefined') {

	class SocialProofBar extends HTMLElement {

		connectedCallback() {
			this.countEl = this.querySelector('[data-social-proof-count]');
			this.baseCount = parseInt(this.dataset.baseCount, 10);

			if (!this.countEl || !this.baseCount || this.baseCount <= 0) return;

			this._scheduleNudge();
		}

		disconnectedCallback() {
			clearTimeout(this._timeout);
		}

		_scheduleNudge() {
			// Every 8-20s, feels organic rather than a fixed tick.
			const delay = 8000 + Math.random() * 12000;
			this._timeout = setTimeout(() => {
				this._nudge();
				this._scheduleNudge();
			}, delay);
		}

		_nudge() {
			// Small variance around the real base count (default +/-4%, at
			// least +/-1) - never an unbounded random walk away from it.
			const variance = Math.max(1, Math.round(this.baseCount * 0.04));
			const offset = Math.floor(Math.random() * (variance * 2 + 1)) - variance;
			const displayed = Math.max(1, this.baseCount + offset);
			this.countEl.textContent = displayed;
		}

	}

	customElements.define('social-proof-bar', SocialProofBar);
}
